/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `data_entry` - Data Entry
 * * `inspection` - Inspection
 * * `offer_ready` - Offer Ready
 * * `in_processing` - In Processing
 */
export enum Status9e7Enum {
  DATA_ENTRY = 'data_entry',
  INSPECTION = 'inspection',
  OFFER_READY = 'offer_ready',
  IN_PROCESSING = 'in_processing',
}
